export default "__VITE_ASSET__BKTsJ5b6__"